<template>
  <div id="addLocationContainer">
    <vs-prompt title="Add Item Location" @accept="addLocation" :active.sync="showLocationForm">
      <div class="con-exemple-prompt  ">
        <!-- selectedData :: {{ selectedData }} -->

        <label>Master Stock Code: {{ selectedMasterStockCode }}</label>
        <vs-divider />
        <label>Sub Stock Code: {{ selectedSubStockCode }}</label>
        <vs-divider />
        <label>Location</label>
        <selectField :endPoint="selectEndpoint" v-model="data.location" :tableParams="locationDetails"
          :defaultValue="selectedData.location" />
        <template v-if="data.location">
          <label>Zone</label>
          <selectField :endPoint="selectEndpoint" :key="data.location.id" v-model="data.zone" :tableParams="zoneDetails"
            :defaultValue="selectedData.zone" />

        </template>
        <template v-if="data.zone">
          <label>Shelf</label>
          <selectField :defaultValue="selectedData.shelf" :endPoint="selectEndpoint" :key="data.zone.id"
            v-model="data.shelf" :tableParams="shelfDetails" />

        </template>

        <span>Remarks</span>
        <vs-input v-model="data.remarks" class="mt-3 w-full" />
      </div>
    </vs-prompt>

    <div class="row">
      <div class="col-md-12">
        <aron-table @selected="selected" :key="refreshTable" uploadEndpoint="/uploadFile"
          endPoint="getWarehouseDataForInventory" filterEndpoint="getWarehouseDataForInventory" key="inventories"
          :formType="formType"></aron-table>
      </div>
    </div>

  </div>
</template>

<script>
import selectField from '@/views/goodsReceive/selectField.vue'
import AronTable from "@/components/aron/table/warehouse.vue";
//register vieDetails component
import { axiosMixin } from "@/mixin/axiosMixin.js";
import { helperMixin } from '@/mixin/helperMixin';
import { mapGetters } from "vuex";
export default {
  mixins: [axiosMixin, helperMixin],
  components: {
    AronTable,
    selectField,
  },
  computed: {
    ...mapGetters({
      gd: "profile/gd"
    }),
    filterEndpoint() {
      return "search_inventories";
    },
    zoneDetails() {
      return {
        tableName: "zones",
        columnId: "id",
        columnName: "name",
        additionalWhereClause: 'locationId=' + this.data.location.id,
      }
    },
    shelfDetails() {
      return {
        tableName: "shelves",
        columnId: "id",
        columnName: "name",
        additionalWhereClause: 'zoneId=' + this.data.zone.id,
      }
    },
  },
  data() {
    return {
      refreshTable: false,
      showLocationForm: false,
      route: this.$route.params.endPoint,
      formType: "sidebarRightSide",
      data: {
        location: "",
        zone: "",
        shelf: "",
        remarks: "",
      },
      selectEndpoint: "getSelectData",
      locationDetails: {
        tableName: "locations",
        columnId: "id",
        columnName: "name",
        additionalWhereClause: '',
      },
      selectedData: {},
      selectedMasterStockCode: '',
      selectedSubStockCode: '',
    };
  },
  methods: {
    startLoading() {
      this.disableSubmitBtn = false;
      this.$vs.loading({
        container: "#addLocationContainer",
        scale: 0.6
      });
    },
    stopLoading() {
      this.disableSubmitBtn = true;
      this.$vs.loading.close("#addLocationContainer > .con-vs-loading");
    },
    selected(data) {
      this.selectedData = {};
      this.data.remarks = ''
      this.selectedData = data;
      this.locationDetails.additionalWhereClause = 'companyId =' + data.compId;
      this.showLocationForm = true;
      this.selectedMasterStockCode = this.decodeValueForSelect(this.gd.masterStockCode.data, data.masterStockCode);
      this.selectedSubStockCode = this.decodeValueForSelect(this.gd.subStockCode.data, data.subStockCode);

      this.data.remarks = data.remarks;

    }, addLocation() {
      this.showLocationForm = true;

      var finalValue = {
        location: this.data.location ? this.data.location.id : null,
        zone: this.data.zone ? this.data.zone.id : null,
        shelf: this.data.shelf ? this.data.shelf.id : null,
        remarks: this.data.remarks,
      };

      // Check if location, zone, and shelf are not empty
      if (!finalValue.location || !finalValue.zone || !finalValue.shelf) {
        this.$vs.notify({
          title: 'Error',
          text: 'Location, zone, or shelf cannot be empty.',
          color: "warning",
          icon: "error",
          htlm: true,
        });
        return false;
      }
      var finalValue = {
        location: this.data.location.id,
        zone: this.data.zone.id,
        shelf: this.data.shelf.id,
        remarks: this.data.remarks,
      }
      this.aronPostPut(
        'inventories',
        'update',
        finalValue,
        this.selectedData.id,

      )
        .then(response => {
          //this.$router.push("/" + this.getCallBack).catch(() => {});
          this.refreshTable = !this.refreshTable;
          this.stopLoading();
          this.showLocationForm = false;
        })
        .catch(error => {
          this.showLocationForm = false;
          this.stopLoading();
        });
    },
  }
};
</script>
<style>
.vs__selected {
  background-color: #10163a !important;
  border-color: #10163a !important;
  margin-right: 0px;
  border-radius: 0px;
}
</style>

